<section class="DatagridMobile">
  @if (data && !isLoading) {
    @if (!hasAnErrorOccurred) {
      @if (data?.length > 0) {
        @for (
          row of config.rowLimit ? (rows | slice: 0 : config.rowLimit) : rows;
          track row;
          let rowIndex = $index
        ) {
          <div class="DatagridMobile__row">
            <div
              class="DatagridMobile__cell"
              [ngClass]="{
                'DatagridMobile__cell--right': cardConfig?.valuesAlignment,
              }"
            >
              <div
                class="DatagridMobile__cell__heading u-flex u-alignCenter u-justifyBetween"
              >
                @if ((config?.columns)[0].format !== 'TEXTWITHICON') {
                  <h6
                    tabindex="0"
                    class="ui-card-header-1"
                    [ngClass]="{
                      'ui-card-header-1--right': cardConfig?.valuesAlignment,
                    }"
                  >
                    <span
                      class="t-bold"
                      [innerHTML]="(config?.columns)[0].label"
                    >
                    </span>
                    @if ((config?.columns)[0].valueInNextLine) {
                      <p>
                        <ng-container
                          *ngTemplateOutlet="headerValue"
                        ></ng-container>
                      </p>
                    } @else {
                      <ng-container
                        *ngTemplateOutlet="headerValue"
                      ></ng-container>
                    }
                    <ng-template #headerValue>
                      <span
                        [ngClass]="{
                          'DatagridMobile__cell__heading--regular':
                            config?.mobileConfiguration?.isExpandable,
                        }"
                        [innerHTML]="getFormattedValue(row, config?.columns[0])"
                      ></span>
                    </ng-template>
                  </h6>
                }
                @if ((config?.columns)[0].format === 'TEXTWITHICON') {
                  <h6
                    tabindex="0"
                    class="ui-card-header-1"
                    [ngClass]="{
                      'ui-card-header-1--right': cardConfig?.valuesAlignment,
                    }"
                  >
                    <lib-notes-text-with-icon
                      [data]="row[config?.columns[0].prop]"
                      [isTextBold]="true"
                    >
                    </lib-notes-text-with-icon>
                  </h6>
                }
                @if ((config?.columns)[0].format === formats.LINK) {
                  <icon
                    name="chevron_right"
                    [config]="{ type: 'link' }"
                    (click)="
                      viewDetail(
                        row,
                        (config?.columns)[0].prop,
                        (config?.columns)[0].routeToProp
                      )
                    "
                    (keydown.enter)="
                      viewDetail(
                        row,
                        (config?.columns)[0].prop,
                        (config?.columns)[0].routeToProp
                      )
                    "
                    tabindex="0"
                  >
                  </icon>
                }
              </div>
            </div>

            @if (config?.columns; as columns) {
              @for (column of expandableColumns; track column) {
                <div
                  class="DatagridMobile__cell"
                  [ngClass]="{
                    'DatagridMobile__cell--right': cardConfig?.valuesAlignment,
                  }"
                >
                  @if (!isActionableColumn(column.format)) {
                    <p
                      tabindex="0"
                      class="DatagridMobile__cell__label"
                      [ngClass]="{
                        'DatagridMobile__cell__label--right':
                          cardConfig?.valuesAlignment,
                      }"
                      [innerHTML]="column.label"
                    ></p>

                    <ng-template
                      [ngTemplateOutlet]="cellOptions"
                      [ngTemplateOutletContext]="{
                        row: row,
                        column: column,
                        index: index,
                      }"
                    >
                    </ng-template>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="mobileButton"
                    ></ng-container>
                  }

                  <ng-template #mobileButton>
                    @if (column.format !== formats.ACTION_ICONS) {
                      <zip-button
                        [config]="{
                          content: column.label,
                          icon:
                            column.format === formats.DOWNLOAD
                              ? 'download'
                              : column.icon,
                          level: 'medium',
                          size: 'fullWidth',
                          isIconRight: true,
                        }"
                        (zipButtonClicked)="
                          onActionClicked(
                            row,
                            column.format === formats.DOWNLOAD
                              ? 'download'
                              : column.action,
                            $event
                          )
                        "
                        [dataLoadEvent]="
                          digitalDataGridService.getDataLoadDownloadEvent(
                            column
                          )
                        "
                      >
                      </zip-button>
                    } @else {
                      <ng-container
                        *ngTemplateOutlet="actionButtons"
                      ></ng-container>
                    }
                    <ng-template #actionButtons>
                      @for (button of column.actionButtons; track button) {
                        <div class="DatagridMobile__cell__actions">
                          @if (
                            !button.conditions ||
                            (row | zipConditional: button.conditions)
                          ) {
                            <zip-button
                              [id]="
                                'actionButton-' +
                                button.icon +
                                rowIndex +
                                dataGridId
                              "
                              [config]="{
                                content: button.action,
                                icon: button.icon,
                                level: button.level || 'medium',
                                size: 'fullWidth',
                                isIconRight: !button.isIconLeft && true,
                              }"
                              (zipButtonClicked)="
                                onActionClicked(row, button.action, $event)
                              "
                            >
                            </zip-button>
                          }
                        </div>
                      }
                    </ng-template>
                  </ng-template>

                  @if (column.tooltipProp) {
                    <tooltip
                      class="DatagridMobile__Tooltip"
                      [config]="{
                        description: getFormattedToolTipValue(row, column),
                      }"
                    ></tooltip>
                  }
                </div>
              }
            }
            @if (cardConfig?.isExpandable) {
              @if (expandedCards[rowIndex]) {
                @for (
                  column of config?.columns.slice(maxVisibleCells);
                  track column
                ) {
                  <div
                    class="DatagridMobile__cell"
                    [ngClass]="{
                      'DatagridMobile__cell--right':
                        cardConfig?.valuesAlignment,
                    }"
                  >
                    @if (!isActionableColumn(column.format)) {
                      <p
                        tabindex="0"
                        class="DatagridMobile__cell__label"
                        [ngClass]="{
                          'DatagridMobile__cell__label--right':
                            cardConfig?.valuesAlignment,
                        }"
                        [innerHTML]="column.label"
                      ></p>

                      <ng-template
                        [ngTemplateOutlet]="cellOptions"
                        [ngTemplateOutletContext]="{
                          row: row,
                          column: column,
                          index: index,
                        }"
                      >
                      </ng-template>
                    } @else {
                      <ng-container
                        *ngTemplateOutlet="mobileButton"
                      ></ng-container>
                    }
                  </div>
                }
              }
              <div
                class="datagrid--mobile__card__toggle"
                [ngClass]="{
                  'datagrid--mobile__card__toggle__expanded':
                    expandedCards[rowIndex],
                }"
              >
                <zip-button
                  [id]="'expandDatagridCard-' + rowIndex"
                  [config]="{
                    id: 'expandDatagridCard-' + rowIndex,
                    content: expandedCards[rowIndex]
                      ? cardConfig.expandButton?.collapseLabel || 'View Less'
                      : cardConfig.expandButton?.expandLabel || 'View More',
                    level: cardConfig.expandButton?.level || 'text',
                    isIconRight: 'true',
                    icon: cardConfig.expandButton?.icon || 'chevron_right',
                  }"
                  (zipButtonClicked)="toggleExpand(rowIndex)"
                >
                </zip-button>
              </div>
            }
          </div>
        }
        @if (footerDetail) {
          <div class="DatagridMobile__FooterDetail">
            <div
              class="DatagridMobile__row"
              [ngClass]="{
                'DatagridMobile__row--plain':
                  cardConfig?.footerStyle === 'plain',
              }"
            >
              <div
                class="DatagridMobile__cell__heading u-flex u-alignCenter u-justifyBetween"
              >
                <h6
                  tabindex="0"
                  class="ui-card-header-1"
                  [ngClass]="{
                    'ui-card-header-1--right': cardConfig?.valuesAlignment,
                  }"
                >
                  @if ((config?.columns)[0].valueInNextLine) {
                    <p>
                      <ng-container
                        *ngTemplateOutlet="headerValue"
                      ></ng-container>
                    </p>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="headerValue"
                    ></ng-container>
                  }
                  <ng-template
                    #headerValue
                    [innerHTML]="
                      getFormattedValue(footerDetail, (config?.columns)[0])
                    "
                  >
                  </ng-template>
                </h6>
              </div>
              @for (column of config?.columns | slice: 1; track column) {
                <div
                  class="DatagridMobile__cell"
                  [ngClass]="{
                    'DatagridMobile__cell--right': cardConfig?.valuesAlignment,
                  }"
                >
                  <p
                    tabindex="0"
                    class="DatagridMobile__cell__label"
                    [ngClass]="{
                      'datagrid--mobile__cell--right':
                        cardConfig?.valuesAlignment,
                    }"
                    [innerHTML]="column.label"
                  ></p>
                  <p
                    tabindex="0"
                    [innerHTML]="getFormattedValue(footerDetail, column) || '—'"
                  ></p>
                </div>
              }
            </div>
          </div>
        }
      } @else {
        <ng-container *ngTemplateOutlet="noData"></ng-container>
      }
    } @else {
      <ng-container *ngTemplateOutlet="error"></ng-container>
    }
  }
  @if (isLoading) {
    <ng-container *ngTemplateOutlet="loading"></ng-container>
  }
</section>
